import type { GetterClass, ToolingState } from '../../../models'

export class StateGetter implements GetterClass {
  static execute(this: void, state: ToolingState): ToolingState['tools'] {
    return state.tools
  }
}
